import { styled, Typography, Box, Button, Tab } from "@mui/material";

export const StyledSubTabsBox = styled(Box)({
  width: "100%",
});

const getSubTabsBarBoxStyles = (theme) => ({
  position: "fixed",
  left: 0,
  right: 0,
  zIndex: 1000,
  backgroundColor: theme.palette.background.paper,
  width: "100%",
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  borderBottom: `1px solid ${theme.palette.divider}`,
  minHeight: "48px",
  height: "48px",
  paddingLeft: "24px",
  paddingRight: "16px",
  top: "125px",
  [theme.breakpoints.down("sm")]: {
    minHeight: "44px",
    height: "44px",
    paddingLeft: 12,
    paddingRight: 8,
    top: "104px",
  },
  [theme.breakpoints.down(480)]: {
    minHeight: "40px",
    height: "40px",
    paddingLeft: 8,
    paddingRight: 6,
    top: "96px",
  },
});

export const StyledSubTabsBarBox = styled(Box)(({ theme }) => ({
  ...getSubTabsBarBoxStyles(theme),
}));

export const StyledSubHeadingTabsGroup = styled(Box)(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  flex: 1,
  minWidth: 0,
  gap: "24px",
  overflow: "hidden",
  [theme.breakpoints.down("sm")]: {
    gap: 12,
  },
  [theme.breakpoints.down(480)]: {
    gap: 4,
  },
}));

export const StyledSubTabsWrapper = styled(Box)({
  display: "flex",
  alignItems: "center",
  flex: 1,
  minWidth: 0,
  overflow: "hidden",
});

export const StyledSubTab = styled(Tab)(({ theme }) => ({
  minHeight: "48px",
  color: "#344767",
  fontWeight: 600,
  textTransform: "none",
  fontSize: "1rem",
  paddingLeft: theme.spacing(1.5),
  paddingRight: theme.spacing(1.5),
  "&.Mui-selected": {
    color: "#1a6beb",
  },
  [theme.breakpoints.down("sm")]: {
    minHeight: "44px",
    fontSize: "0.875rem",
    paddingLeft: theme.spacing(1.25),
    paddingRight: theme.spacing(1.25),
  },
  [theme.breakpoints.down(480)]: {
    minHeight: "40px",
    minWidth: "auto",
    fontSize: "0.8125rem",
    paddingLeft: theme.spacing(1),
    paddingRight: theme.spacing(1),
  },
}));

export const StyledSubHeaderButton = styled(Button)(({ theme }) => ({
  marginLeft: 16,
  textTransform: "none",
  color: "#1a6beb",
  flexShrink: 0,
  [theme.breakpoints.down("sm")]: {
    marginLeft: 8,
    paddingLeft: theme.spacing(1.5),
    paddingRight: theme.spacing(1.5),
    fontSize: "0.875rem",
  },
  [theme.breakpoints.down(480)]: {
    marginLeft: 4,
    paddingLeft: theme.spacing(1),
    paddingRight: theme.spacing(1),
    fontSize: "0.8125rem",
  },
}));

export const StyledSubHeadingText = styled(Typography)(({ theme }) => ({
  fontWeight: 600,
  fontSize: "16px",
  lineHeight: "24px",
  color: "#344767",
  flexShrink: 0,
  [theme.breakpoints.down("sm")]: {
    fontSize: "14px",
    lineHeight: "20px",
  },
  [theme.breakpoints.down(480)]: {
    fontSize: "12px",
    lineHeight: "18px",
  },
}));

export const StyledSubTabComponent = styled(Box)(({ theme }) => ({
  marginTop: "48px",
  padding: "24px 0 0 0",
  width: "100%",
  [theme.breakpoints.down("sm")]: {
    marginTop: "44px",
    padding: "16px 0",
  },
  [theme.breakpoints.down(480)]: {
    marginTop: "40px",
    padding: "12px 8px",
  },
}));
